import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import path from 'path'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp APK Anti-Ban Version Download for Android 2025`,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `To use GB WhatsApp APK without being banned, you can download GB WhatsApp APK file on this site. We always update the latest version APK file.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/'
				}
			]
		},
		component: Home,
	},
	{
		path: '/gb-whatsapp-apk-download',
		name: 'en-download',
		meta: {
			appname: 'GBWhatsApp',
			title: `Install GB WhatsApp App Updated 2025 For Android`,
			keywords: 'gbwhatsapp apk download, gb whatsapp apk download, gbwhatsapp download, gb whatsapp download',
			description: `Official page provides safe and lasted source of GB WhatsApp APK for Android users seeking for premium features. Get it Now!`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/gb-whatsapp-apk-download/'
				}
			]
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/gbwhatsapp-ban-issues/',
		name: 'gbwhatsapp-ban-issues',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWhatsApp Ban Issues: Temporary and Permanent Ban Guide`,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Learn everything about GBWhatsApp ban issues in 2025, including how to recover from temporary bans, avoid permanent bans, and use GBWhatsApp safely. `,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/gbwhatsapp-ban-issues/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'Anti Ban',
				},
			],
		},
		component: () => import('@/views/banIssue.vue'),
	},
	{
		path: '/gb-whatsapp-for-pc/', 
		name: 'gb-whatsapp-for-pc',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp For PC|Download APK on Windows 10,8,7 `,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Download GB WhatsApp for PC on Windows 10/8/7 using an Android emulator. Follow easy steps to install GB WhatsApp APK and enjoy chatting on a bigger screen with full features!`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/gb-whatsapp-for-pc/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'For PC',
				},
			],
		},
		component: () => import('@/views/pc.vue'),
	},
	{
		path: '/gb-whatsapp-ios/', 
		name: 'gb-whatsapp-ios',
		meta: {
			appname: 'GBWhatsApp',
			title: `Is GB WhatsApp Available for iOS (iPhone) ? Truth You Should Know`,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Looking for GB WhatsApp for iOS (iPhone)? Here's the truth: no official version exists. Learn what you should know before downloading fake iOS GB WhatsApp.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/gb-whatsapp-ios/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'For IOS',
				},
			],
		},
		component: () => import('@/views/ios.vue'),
	},
	{
		path: '/ob-whatsapp/', 
		name: 'ob-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download OB WhatsApp For Android [Anti-Ban] Safely 2025`,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: ` Download OB WhatsApp anti-ban version for Android and enjoy advanced messaging features with the latest OB WhatsApp APK.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/ob-whatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'OB WhatsApp',
				},
			],
		},
		component: () => import('@/views/ob.vue'),
	},
	{
		path: '/blogs',
		name: 'blogs',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Blogs: What You Should Know`,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Discover GB WhatsApp tutorials, troubleshooting guides, news updates, mod tips, and helpful resources. Stay updated and get better GB WhatsApp experience.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/blogs/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'blogs',
				},
			],
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/blogs/uninstall-gbwhatsapp-safely',
		name: 'en-blog1',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Uninstall GBWhatsApp Safely from Your Android`,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Learn how to uninstall GBWhatsApp safely from your Android device. Protect your data, free up space, and switch to secure messaging alternatives easily.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/blogs/uninstall-gbwhatsapp-safely/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'blogs',
				},
			],
		},
		component: () => import('@/views/blog1.vue'),
	},
	{
		path: '/blogs/unlocking-gb-whatsapp-anti-revoke-messages',
		name: 'en-blog2',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Read Deleted Messages on WhatsApp By Using GBWhatsApp`,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Learn how to access and read deleted messages on WhatsApp by using GBWhatsApp easily. No need to root.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/blogs/unlocking-gb-whatsapp-anti-revoke-messages/'
				}
			]
		},
		component: () => import('@/views/blog2.vue'),
	},
	{
		path: '/use-gb-whatsapp-without-being-banned',
		name: 'en-blog3',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Use GB WhatsApp without Being Banned `,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Learn how to use GB WhatsApp safely without getting banned. Follow tips to avoid detection, stay updated, and protect your account from suspension.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/use-gb-whatsapp-without-being-banned/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'How to Use GB WhatsApp without Being Banned',
				},
			],
		},
		component: () => import('@/views/blog3.vue'),
	},
	{
		path: '/what-is-blue-whatsapp-plus',
		name: 'en-blog4',
		meta: {
			appname: 'GBWhatsApp',
			title: `What is Blue WhatsApp Plus?`,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Explore what Blue WhatsApp Plus offers, from extra features to privacy upgrades. Discover how it differs from the official WhatsApp in our full guide.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/what-is-blue-whatsapp-plus/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'What is Blue WhatsApp Plus?',
				},
			],
		},
		component: () => import('@/views/blog4.vue'),
	},
	{
		path: '/blogs/download-whatsapp-status-video',
		name: 'en-blog5',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download WhatsApp Status Video Easily with GBWhatsApp`,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Save contacts status videos with one click by using GB WhatsApp. Read this blog to learn the simple steps. It's easy to save WhatsApp status videos.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/blogs/download-whatsapp-status-video/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'Download WhatsApp Status Video Easily with GBWhatsApp',
				},
			],
		},
		component: () => import('@/views/blog5.vue'),
	},
	{
		path: '/how-to-customize-gb-whatsapp-on-your-device/',
		name: 'en-blog6',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Customize GB WhatsApp on Your Device`,
			keywords: 'Customize GB WhatsApp',
			description: `Learn how to easily customize GB WhatsApp with unique themes, fonts, and emojis. Personalize your chat experience and make the app truly yours with simple steps.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/how-to-customize-gb-whatsapp-on-your-device/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'How to Customize GB WhatsApp on Your Device',
				},
			],
		},
		component: () => import('@/views/blog6.vue'),
	},
	{
		path: '/new-release-gb-whatsapp-updated-v18.50-version/',
		name: 'en-blog7',
		meta: {
			appname: 'GBWhatsApp',
			title: `New Release: GB WhatsApp Updated v18.50 Version`,
			keywords: 'GB WhatsApp v18.50',
			description: `GB WhatsApp v18.50 is here with better privacy, new features, smoother performance, and full customization. Download the latest version now!`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/new-release-gb-whatsapp-updated-v18.50-version/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'New Release: GB WhatsApp Updated v18.50 Version',
				},
			],
		},
		component: () => import('@/views/blog7.vue'),
	},
	{
		path: '/gb-whatsapp-support-how-to-get-help-and-fix-issues/',
		name: 'en-blog8',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Support: How to Get Help & Fix Issues`,
			keywords: 'GB WhatsApp Support',
			description: `GB WhatsApp Support helps users resolve login errors, feature glitches, and update problems quickly. Learn how to get the right assistance and fix issues fast.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/gb-whatsapp-support-how-to-get-help-and-fix-issues/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'GB WhatsApp Support: How to Get Help & Fix Issues',
				},
			],
		},
		component: () => import('@/views/blog8.vue'),
	},
	{
		path: '/can-i-use-gbwhatsapp-and-whatsapp-with-same-number/',
		name: 'en-blog9',
		meta: {
			appname: 'GBWhatsApp',
			title: `Can I use GBWhatsApp and WhatsApp with the same phone number?`,
			keywords: 'use GBWhatsApp and WhatsApp with same number',
			description: `Wondering if you can use GBWhatsApp and WhatsApp with the same number? Learn the risks, limitations, and best practices for dual messaging apps.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/can-i-use-gbwhatsapp-and-whatsapp-with-same-number/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'Can I use GBWhatsApp and WhatsApp with the same phone number?',
				},
			],
		},
		component: () => import('@/views/blog9.vue'),
	},
	{
		path: '/restore-deleted-media-on-gbwhatsapp-without-backup/',
		name: 'en-blog10',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Restore Deleted Media on GBWhatsApp Without Backup`,
			keywords: 'Restore GBWhatsApp Deleted Media',
			description: `Restore GBWhatsApp deleted media quickly without backup using these proven methods. Recover your photos, videos, and audio files effortlessly today.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/restore-deleted-media-on-gbwhatsapp-without-backup/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'How to Restore Deleted Media on GBWhatsApp Without Backup',
				},
			],
		},
		component: () => import('@/views/blog10.vue'),
	},
	{
		path: '/how-to-fix-gbwhatsapp-not-working-on-android/',
		name: 'en-blog11',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Fix GBWhatsApp Not Working on Android`,
			keywords: 'GBWhatsApp Not Working on Android',
			description: `How to fix GBWhatsApp not working on Android with easy steps to solve crashes, connection errors, and update problems quickly.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/how-to-fix-gbwhatsapp-not-working-on-android/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'How to Fix GBWhatsApp Not Working on Android',
				},
			],
		},
		component: () => import('@/views/blog11.vue'),
	},
	{
		path: '/what-is-whatsapp-aero/',
		name: 'en-blog12',
		meta: {
			appname: 'GBWhatsApp',
			title: `What is WhatsApp Aero?`,
			keywords: 'What is WhatsApp Aero',
			description: `WhatsApp Aero brings flexible design, privacy tools, and improved media sharing to Android. Ideal for users who love personalization and a unique interface beyond regular WhatsApp.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/what-is-whatsapp-aero/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'What is WhatsApp Aero?',
				},
			],
		},
		component: () => import('@/views/blog12.vue'),
	},
	{
		path: '/gbwhatsapp-privacy/',
		name: 'en-blog13',
		meta: {
			appname: 'GBWhatsApp',
			title: `Does GBWhatsApp Really Improve Privacy? A Deep Dive`,
			keywords: 'GBWhatsApp privacy, hide online status GBWhatsApp, secure GBWhatsApp, GBWhatsApp safety, WhatsApp mod privacy',
			description: `GBWhatsApp promises advanced privacy settings, from hiding online status to locking chats. But does it really improve privacy compared to the official WhatsApp? Here's an honest breakdown.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/gbwhatsapp-privacy/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'Does GBWhatsApp Really Improve Privacy? A Deep Dive',
				},
			],
		},
		component: () => import('@/views/blog13.vue'),
	},
	{
		path: '/backup-gbwhatsapp-data/',
		name: 'en-blog14',
		meta: {
			appname: 'GBWhatsApp',
			title: `Safeguard Your Chats: How to Back Up Your Data on GBWhatsApp？`,
			keywords: 'GBWhatsApp backup',
			description: `Easily back up GBWhatsApp data to safeguard your chats, photos, and media. Ensure secure storage and seamless recovery with verified backup methods.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/backup-gbwhatsapp-data/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'Safeguard Your Chats: How to Back Up Your Data on GBWhatsApp？',
				},
			],
		},
		component: () => import('@/views/blog14.vue'),
	},
	{
		path: '/gbwhatsapp-voice-changer-feature/',
		name: 'en-blog15',
		meta: {
			appname: 'GBWhatsApp',
			title: `Exploring GBWhatsApp's Hidden Gem: The Voice Changer Feature`,
			keywords: 'GBWhatsApp, voice changer, chat features',
			description: `A deep look into GBWhatsApp's Voice Changer — how it works, how to enable it, and why users love this fun, expressive tool.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/gbwhatsapp-voice-changer-feature/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'Voice Changer Feature',
				},
			],
		},
		component: () => import('@/views/blog15.vue'),
	},
	{
		path: '/gbwhatsapp-live-wallpapers/',
		name: 'en-blog16',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Use Live Wallpapers in GBWhatsApp Chat Screen`,
			keywords: 'GBWhatsApp, live wallpaper, chat screen',
			description: `Bring your chats to life by setting live wallpapers in GBWhatsApp — subtle motion, personal style, and a fresh look for your daily conversations.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/gbwhatsapp-live-wallpapers/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'Live Wallpapers',
				},
			],
		},
		component: () => import('@/views/blog16.vue'),
	},
	{
		path: '/fix-gbwhatsapp-message-sending-receiving/',
		name: 'en-blog17',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Fix GB WhatsApp Not Sending or Receiving Messages`,
			keywords: 'fix GB WhatsApp not sending or receiving messages',
			description: `Comprehensive solutions for GB WhatsApp not sending or receiving messages. Step-by-step troubleshooting for sending and receiving failures, network issues, and connection errors.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/fix-gbwhatsapp-message-sending-receiving/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'https://gbwaapplus.com/' },
				{
					text: 'Fix GB WhatsApp Not Sending or Receiving Messages',
				},
			],
		},
		component: () => import('@/views/blog17.vue'),
	},
	{
		path: '/privacy',
		name: 'privacy',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Website Privacy Policy`,
			// keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `How does our site deal with your information? Read the privacy policies.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/privacy/'
				},
			],
			// noindex: true
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/contact-us',
		name: 'contact-us',
		meta: {
			appname: 'GBWhatsApp',
			title: `Contact Us`,
			// keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Contact us if you have any questions about the app, we will get back to you soon.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/contact-us/'
				},
			],
			// noindex: true
		},
		component: () => import('@/views/contact.vue'),
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: `Disclaimer`,
			// keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `View the Disclaimer for our site. We are not affiliated with GBWhatsApp developers and only provide information and safe download sources for users.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/disclaimer/'
				},
			],
			// noindex: true
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/about-us',
		name: 'about-us',
		meta: {
			appname: 'GBWhatsApp',
			title: `About GB WhatsApp and Our Site`,
			// keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `We build this site for users to download GB WhatsApp safely and for free. Learn more about us on this page.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/about-us/'
				}
			],
			// noindex: true
		},
		component: () => import('@/views/about.vue'),
	},
	{
		path: '/terms-of-use',
		name: 'terms-of-use',
		meta: {
			appname: 'GBWhatsApp',
			title: `Terms of Use`,
			// keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Read the Terms of Use for gbwaapplus.com. We are not the developers of GBWhatsApp and only provide safe download links and information.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/terms-of-use/'
				}
			],
			// noindex: true
		},
		component: () => import('@/views/termsUse.vue'),
	},
	{
		path: '/transfer',
		name: 'transfer',
		meta: {
			appname: 'GBWhatsApp',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwaapplus.com/transfer/'
				}
			]
		},
		component: () => import('@/views/transfer.vue'),
	},

]

// export const constRoutesM = [
// 	{
// 		path: '/',
// 		name: 'Home',
// 		meta: {
// 			appname: 'GBWhatsApp',
// 			topLogo: require('@/assets/gb/GB_new_icon_small@2x.png'),
// 			footLogo: require('@/assets/gb/icon_GB_new@2x.png'),
// 			showBreadcrumb: true,
// 			showTelegram: true,
// 		},
// 		// component: HomeM,
// 	},
// 	{
// 		path: '/download',
// 		name: 'download',
// 		meta: {
// 			appname: 'GBWhatsApp',
// 			topLogo: require('@/assets/gb/GB_new_icon_small@2x.png'),
// 			footLogo: require('@/assets/gb/icon_GB_new@2x.png'),
// 			showBreadcrumb: false,
// 		},
// 		component: () => import('@/components/download.vue'),
// 	},
// ]

let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
